import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';
import { Col, Row, Form } from 'react-bootstrap';

import { useStore } from '../../../store';
import { FormControl } from '../../../facturotopia';
import CalendarDateRangePicker from '../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker';

class DashboardClientesFilters extends Component {
  state = {
    index: '',
    empresa: '',
    emisor: '',
    pac: '',
  };

  constructor(props) {
    super(props);

    const {
      filters: { from: asFrom, to: asTo, empresa, emisor, pac },
    } = this.props;

    const from = !!asFrom ? moment(asFrom) : moment().subtract(2, 'months');
    const to = !!asTo ? moment(asTo) : moment();

    const check = !!empresa || !!emisor || !!pac ? true : false;

    this.state = {
      from: from.toDate(),
      to: to.toDate(),
      empresa: empresa,
      emisor: emisor,
      pac: pac,
      check_filter: check,
    };
  }

  get optionsEmpresas() {
    const { cliente = {} } = this.props;
    const { empresas } = cliente;

    if (!empresas) {
      return [];
    }

    const filtered = empresas.map((item) => {
      return {
        label: item.nombre,
        value: item.id,
      };
    });

    return [
      {
        label: 'Empresa',
        value: '',
      },
    ].concat(filtered);
  }

  get optionsEmisores() {
    const { cliente = {} } = this.props;
    const { emisores } = cliente;

    if (!emisores) {
      return [];
    }

    const filtered = emisores.map((item) => {
      return {
        label: item.rfc,
        value: item.id,
      };
    });

    return [
      {
        label: 'Emisor',
        value: 'Emisor',
      },
    ].concat(filtered);
  }

  handleOnDateChange = (date) => {
    const { filters, cliente } = this.props;

    const from = moment(date[0]);
    const to = moment(date[1]);

    this.props.summary(cliente.id, {
      ...filters,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD'),
    });
  };

  handleOnFiltersChange = (value) => {
    const { filters, cliente } = this.props;

    this.props.summary(cliente.id, {
      ...filters,
      ...value,
    });

    this.setState({
      ...value,
    });
  };

  handleOnChange = (value) => {
    this.handleOnFiltersChange(value);
  };

  handleOnChange = (value) => {
    this.handleOnFiltersChange(value);
  };

  handleOnCheckFilterChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked,
    });
  };

  render() {
    const { from, to, empresa, emisor, pac, check_filter } = this.state;

    return (
      <>
        <Row>
          <Col
            xs={12}
            sm={6}
            md={6}
            lg={3}
          >
            <CalendarDateRangePicker
              value={[from, to]}
              onDateChange={this.handleOnDateChange}
            />
          </Col>

          <Col className="text-right">
            <Form.Group
              controlId="filters"
              className="custom-permissions-input"
            >
              <Form.Check
                type="switch"
                name="check_filter"
                label="Filtrado"
                checked={check_filter === true}
                onChange={this.handleOnCheckFilterChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {!!check_filter && (
          <Row className="mt-3">
            <Col
              xs={12}
              sm={4}
              md={4}
              lg={3}
            >
              <FormControl
                type="select"
                label="Pac"
                name="pac"
                placeholder=""
                help=""
                value={pac}
                options={Pacs}
                onChange={this.handleOnChange}
              />
            </Col>
            <Col
              xs={12}
              sm={4}
              md={4}
              lg={3}
            >
              <FormControl
                type="select"
                label="Empresa"
                name="empresa"
                placeholder=""
                help=""
                value={empresa}
                options={this.optionsEmpresas}
                onChange={this.handleOnChange}
              />
            </Col>
            <Col
              xs={12}
              sm={4}
              md={4}
              lg={3}
            >
              <FormControl
                type="ahead"
                label="Emisor"
                name="emisor"
                placeholder=""
                help=""
                value={emisor}
                options={this.optionsEmisores}
                onChange={this.handleOnChange}
              />
            </Col>
          </Row>
        )}
      </>
    );
  }
}

const Pacs = [
  {
    label: 'Pac',
    value: '',
  },
  {
    label: 'Finkok',
    value: 'finkok',
  },
  {
    label: 'Timbox',
    value: 'timbox',
  },
  {
    label: 'Turbo Pac',
    value: 'turbo-pac',
  },
  {
    label: 'Smart Web',
    value: 'sw',
  },
];

const mapState = (state) => {
  return state.reporte_consumo.info;
};

const mapActions = (actions) => {
  return {
    summary: actions.reporte_consumo.info.summary,
  };
};

export default connect(useStore, mapState, mapActions)(DashboardClientesFilters);
